module.exports = __webpack_public_path__ + "static/approves-6d3564bbad61b982db174c5663e2cb7c.gif";